module.exports = __webpack_public_path__ + "af9c11c1b1cf3f2bfc74b7b85c9d5c3b.jpg";